import { render } from "./SelecaoVisualizacao.vue?vue&type=template&id=505fe2e4&scoped=true&ts=true"
import script from "./SelecaoVisualizacao.vue?vue&type=script&lang=ts"
export * from "./SelecaoVisualizacao.vue?vue&type=script&lang=ts"

import "./SelecaoVisualizacao.vue?vue&type=style&index=0&id=505fe2e4&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505fe2e4"]])

export default __exports__